export const bonus_buy_widget = {
	BONUS_BUY_WIDGET_TITLE: {
		value: 'BUY BONUS',
		config: {
			fill: '#CFDBB5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	BONUS_BUY_WIDGET_VALUE: {
		value: '$400',
		config: {
			fill: ['#92CF25', '#225A0F'],
			lineHeight: 1,
			fontFamily: 'Poppins SemiBold',
			fontSize: 42
		}
	}
};
